import script from "./LaputaBookDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaBookDetail.vue?vue&type=script&setup=true&lang=js"

import "./LaputaBookDetail.vue?vue&type=style&index=0&id=064ec75a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-064ec75a"]])

export default __exports__